import { render } from "./ejection-charge.vue?vue&type=template&id=0b640b6e"
import script from "./ejection-charge.vue?vue&type=script&lang=js"
export * from "./ejection-charge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__